<template>
  <div>
    <b-alert
      variant="warning"
      dismissible
      :show="autoLogout.isAutoLogout">
      <div v-if="autoLogout.isAutoLogout">
        {{ $t('message.signIn.autoLogout', {salutation: $t('enums.salutations.' +  autoLogout.salutation), firstName: autoLogout.firstName, lastName: autoLogout.lastName}) }}
      </div>
    </b-alert>
    <b-card class="rounded-0">
      <h4 class="text-center">{{ $t('message.signIn.title') }}</h4>
      <b-form class="mt-3 p-3" @submit.prevent="submit">
        <b-form-group :state="$v.authData.email.$error ? false : null"
                      :invalid-feedback="$t('error.signIn.email')">
          <label>
            {{ $t('message.signIn.label.email') }}
            <span class="text-danger">*</span>
          </label>
          <b-form-input id="email"
                        class="rounded-0"
                        v-model="authData.email"
                        autofocus
                        :placeholder="$t('message.signIn.input.placeholder.email')"
                        :state="$v.authData.email.$error ? false : null"
                        v-on:change="$v.authData.email.$touch()">
          </b-form-input>
        </b-form-group>
        <b-form-group class="mt-4"
                      :state="$v.authData.password.$error ? false : null"
                      :invalid-feedback="$t('error.signIn.password')">
          <label>
            Passwort
            <span class="text-danger">*</span>
          </label>
          <b-form-input id="password"
                        class="rounded-0"
                        v-model="authData.password"
                        type="password"
                        :placeholder="$t('message.signIn.input.placeholder.password')"
                        :state="$v.authData.password.$error ? false : null"
                        v-on:change="$v.authData.password.$touch()">
          </b-form-input>
        </b-form-group>
        <b-form-row class="mt-4">
          <b-col class="text-right">
            <router-link to="/resetPassword">{{ $t('message.resetPassword.title') }}</router-link>
          </b-col>
        </b-form-row>
        <b-form-row class="mt-4">
          <b-col>
            <b-btn type="submit"
                   variant="primary"
                   class="w-100 p-3 rounded-0"
                   :disabled="$v.$invalid">{{ $t('message.signIn.title') }}
            </b-btn>
          </b-col>
        </b-form-row>
        <b-form-row class="mt-4">
          <b-col class="text-center">
            <p>{{ $t('message.signUp.question') }}
              <router-link to="/signup">{{ $t('message.signUp.link') }}</router-link>
            </p>
          </b-col>
        </b-form-row>
      </b-form>
    </b-card>
  </div>
</template>

<script>
  import {email, required} from 'vuelidate/lib/validators'

  export default {
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.authData.email = to.query.email
      })
    },
    created () {
      this.signInAttempts = 0
    },
    computed: {
      autoLogout () {
        return this.$store.getters.autoLogout
      }
    },
    data () {
      return {
        authData: {
          email: null,
          password: null
        },
        signInAttempts: 0
      }
    },
    methods: {
      submit () {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          this.$store.dispatch('signIn', this.authData)
            .then(() => {
              if (this.$route.query.redirect) {
                this.$router.replace(this.$route.query.redirect)
              } else {
                this.$router.replace('/')
              }
            })
            .catch((error) => {
              if (error.response !== undefined) {
                if (error.response.data.errorCode === 'USER_DECLARED_DEAD') {
                  return this.showErrorMsg({
                    message: this.$t('error.signIn.death')
                  })
                } else {
                  return this.showErrorMsg({
                    message: this.$t('error.signIn.error')
                  })
                }
              } else {
                if (error.code === 'UserNotConfirmedException') {
                  this.$router.push({path: '/signup/confirm', query: {email: this.authData.email}})
                }
                if (this.signInAttempts === 3) {
                  // TODO send email for 3 wrong sign in attempts
                }
                this.signInAttempts += 1
                return this.showErrorMsg({
                  message: this.$t('error.signIn.submit')
                })
              }
            })
        }
      }
    },
    validations: {
      authData: {
        email: {
          email,
          required
        },
        password: {
          required
        }
      }
    },
    notifications: {
      showErrorMsg: {
        type: 'error'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/auth/SignIn.vue